module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av67-efad329d2a36b5c8b85c2144a7967e44.jpg";